// Theme color constants for light and dark modes
export const lightTheme = {
  background: '#fff',
  backgroundLight: '#f8fafc',
  backgroundHover: '#f1f5f9',
  text: '#334155',
  textSecondary: '#64748b',
  textLight: '#94a3b8',
  border: '#e5e7eb',
  borderLight: '#f1f5f9',
  primary: '#2563eb',
  primaryHover: '#1d4ed8',
  error: '#ef4444',
  success: '#22c55e',
  card: '#fff',
  shadow: 'rgba(30,41,59,0.06)',
  shadowHover: 'rgba(30,41,59,0.15)',
};

export const darkTheme = {
  background: '#1e293b',
  backgroundLight: '#0f172a',
  backgroundHover: '#334155',
  text: '#f1f5f9',
  textSecondary: '#cbd5e1',
  textLight: '#94a3b8',
  border: '#334155',
  borderLight: '#475569',
  primary: '#3b82f6',
  primaryHover: '#2563eb',
  error: '#f87171',
  success: '#4ade80',
  card: '#1e293b',
  shadow: 'rgba(0,0,0,0.3)',
  shadowHover: 'rgba(0,0,0,0.5)',
};

// Helper function to get theme colors
export const getThemeColors = (isDark) => {
  return isDark ? darkTheme : lightTheme;
};

// Helper function to create theme-aware style object
export const createThemeStyle = (isDark, styleFn) => {
  const colors = getThemeColors(isDark);
  return styleFn(colors);
};



